import { HierarchyContextProps, IHierarchyActionAddDomainReplacement } from "../interface";
import { hcr_checkDRs } from "./hcr_checkDRs";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Adds a domain replacement to the current hierarchy.
 *
 * @param state - The current hierarchy context state.
 * @param action - The add-domain-replacement action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_addDomainReplacement = (
  state: HierarchyContextProps,
  action: IHierarchyActionAddDomainReplacement,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);

  return hcr_updateChangedFlag(
    hcr_checkDRs({
      ...state,
      hierarchy: {
        ...state.hierarchy,
        domainReplacements: [...state.hierarchy.domainReplacements, action.domainReplacement],
      },
    }),
    action,
  );
};
